import React from "react";
import { Link } from "react-router-dom";
import "./CarerrPageHeader.scss";

function CareerPageHeader(props) {
  const CommonHeaderFonts = {
    // fontFamily: "Source Sans Pro ,sans serif",
    fontSize: "16px",
    fontWeight: "600",
    fontStyle: "normal",
  };
   const fontColor = props?.companyData?.fontColor;

  return (
    <div className="header">
      <div className="header-container ">
        <div className="container-fluid">
          <div className="menu-full-wrap">
            <div className="site-branding-wrap">
              {props?.companyData?.logo?.url ?
                <Link>

                  <img
                    alt="logo"
                    className="logo-class"
                    src={
                      props?.companyData?.logo?.url
                    }
                  />

                </Link>
                : <span className="logo-class brand-text">{props?.companyData?.name}</span>}
            </div>
            <div className="header-right">
              <nav className="site-header">
                <ul style={CommonHeaderFonts}>
                  {props?.companyData?.navBars && props?.companyData?.navBars.length > 0 && props?.companyData?.navBars.map((ele) => (
                    <li id={ele.text}>
                      <Link 
                        className="link-container" to={ele.link}>
                        {ele.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CareerPageHeader;
